import DefaultPageContent from './DefaultPageContent';
import DefaultPageContentContainer from './DefaultPageContent.container';

export default DefaultPageContentContainer(DefaultPageContent);
